var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntelligentwritingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 11.3972603,
    height: 14.4657534,
    rx: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-325.000000, -6114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-22",
    transform: "translate(325.000000, 6114.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u77E9\\u5F62",
    fill: "#00D097",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32876712,4.14126712 C8.6049095,4.14126712 8.82876712,4.36512475 8.82876712,4.64126712 C8.82876712,4.88672701 8.65189196,5.09087549 8.41864276,5.13321145 L8.32876712,5.14126712 L3.26626712,5.14126712 C2.99012475,5.14126712 2.76626712,4.9174095 2.76626712,4.64126712 C2.76626712,4.39580723 2.94314228,4.19165875 3.17639149,4.14932279 L3.26626712,4.14126712 L8.32876712,4.14126712 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79751712,7.42893836 C6.0736595,7.42893836 6.29751712,7.65279598 6.29751712,7.92893836 C6.29751712,8.17439824 6.12064196,8.37854673 5.88739276,8.42088269 L5.79751712,8.42893836 L3.26626712,8.42893836 C2.99012475,8.42893836 2.76626712,8.20508073 2.76626712,7.92893836 C2.76626712,7.68347847 2.94314228,7.47932999 3.17639149,7.43699403 L3.26626712,7.42893836 L5.79751712,7.42893836 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#4AD7FF",
    x: 8.4,
    y: 6.1369863,
    width: 7.6,
    height: 8.32876712,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0916096,8.74400685 C14.367752,8.74400685 14.5916096,8.96786447 14.5916096,9.24400685 C14.5916096,9.48946674 14.4147344,9.69361522 14.1814852,9.73595118 L14.0916096,9.74400685 L10.2799658,9.74400685 C10.0038234,9.74400685 9.77996575,9.52014922 9.77996575,9.24400685 C9.77996575,8.99854696 9.95684091,8.79439848 10.1900901,8.75206252 L10.2799658,8.74400685 L14.0916096,8.74400685 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0398116,11.5933219 C13.315954,11.5933219 13.5398116,11.8171795 13.5398116,12.0933219 C13.5398116,12.3387818 13.3629365,12.5429303 13.1296873,12.5852662 L13.0398116,12.5933219 L10.2799658,12.5933219 C10.0038234,12.5933219 9.77996575,12.3694643 9.77996575,12.0933219 C9.77996575,11.847862 9.95684091,11.6437135 10.1900901,11.6013776 L10.2799658,11.5933219 L13.0398116,11.5933219 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentwritingIcon);
export default __webpack_public_path__ + "static/media/Intelligentwriting_icon.8448fb063ea370844f5e9cc3c98e0c59.svg";
export { ForwardRef as ReactComponent };